"use client";

import { useCallback, useMemo, useState } from "react";
import type { HubExchangeAccount } from "@cede/types";
import type { ExchangeSessionResult } from "../types";
import { useCexPerpsConnection } from "./useCexPerpsConnection";

export function useCexPerpsSession(): ExchangeSessionResult {
  const connection = useCexPerpsConnection();

  const [selectedAccountId, setSelectedAccountId] = useState<number | null>(null);
  const selectedAccount = useMemo(() => {
    const accts = connection.accounts;
    if (selectedAccountId != null) return accts.find((a) => a.id === selectedAccountId) ?? null;
    return accts[0] ?? null;
  }, [connection.accounts, selectedAccountId]);

  const setSelectedAccount = useCallback(
    (account: HubExchangeAccount | null) => setSelectedAccountId(account?.id ?? null),
    [],
  );

  return {
    connection,
    sessionStatus: connection.sessionStatus,
    accounts: connection.accounts,
    selectedAccount,
    setSelectedAccount,
    handleSetupAction: () => {},
    isSettingUp: false,
    requiredWalletRole: null,
    requiredWalletAddress: undefined,
    exchangeAccountAddress: undefined,
    needsDeposit: false,
    preparationStep: null,
    setupLabel: undefined,
  };
}
